import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';
import { map } from 'rxjs/operators';
import { DEFAULT_ERROR_TYPE_LABELS } from 'htx-ui-library';

@Injectable({ providedIn: 'root' })
export class FormErrorMessagesService {
  private readonly t = inject(TranslocoService);

  /**
   * Reactive error messages – updates whenever translations load or language changes.
   * Falls back to English defaults until the translation file is available.
   */
  readonly messages = toSignal(
    this.t.selectTranslateObject('formErrors').pipe(
      map((obj: Record<string, string>) => ({
        ...DEFAULT_ERROR_TYPE_LABELS,
        ...obj
      }))
    ),
    { initialValue: DEFAULT_ERROR_TYPE_LABELS }
  );
}
